
export const nav = async (err) => {
  if (err) {
    console.error(err);
  }

  var lastScrollTop = 0;
    window.onscroll = function() {
        var st = window.pageYOffset || document.documentElement.scrollTop;
        var currentScrollPos = window.pageYOffset;
      
        // 20 is an arbitrary number here, just to make you think if you need the prevScrollpos variable:
        if (st > lastScrollTop) {
          // I am using 'display' instead of 'top':
          document.getElementsByClassName("main-header")[0].classList.add("main-header--hide");

          if (document.getElementsByClassName('scroll-navigation').length) {
            document.getElementsByClassName("scroll-navigation")[0].classList.add("scroll-navigation--down");
          }
        } else {
          document.getElementsByClassName("main-header")[0].classList.remove("main-header--hide");

          if (document.getElementsByClassName('scroll-navigation').length) {
            document.getElementsByClassName("scroll-navigation")[0].classList.remove("scroll-navigation--down");
          }
        }

        if (currentScrollPos < 10) {
            // I am using 'display' instead of 'top':
            document.getElementsByClassName("main-header")[0].classList.add("main-header--attop");
          } else {
            document.getElementsByClassName("main-header")[0].classList.remove("main-header--attop");
          }


          if (document.getElementsByClassName('footer-button').length) {
            if (currentScrollPos > 600) {
              // I am using 'display' instead of 'top':
              document.getElementsByClassName("footer-button")[0].classList.add("footer-button--show");
            } else {
              if (document.getElementsByClassName('footer-button--show').length) {
                document.getElementsByClassName("footer-button")[0].classList.remove("footer-button--show");
              }
            }
        }

        lastScrollTop = st <= 0 ? 0 : st;
      }
  
};

import.meta.webpackHot?.accept(nav);
